import { useEffect, useMemo, useState } from 'react';
import { AuthService } from '@core/Web/services/AuthService';
import { useAuth } from '@core/gameengine/state/auth';
import { GlobalBus } from '@core/Bus/EventBus';
import { SKYX_NEW_PLAYER_AVATAR_CHANGED } from '@core/lobby/skyxNewPanelEvents';
import {
  ensureServerAvatarPool,
  resolvePlayerAvatarUrl,
} from '@core/utils/skyxPlayerAvatar';

/**
 * Resolves a skyx_new player avatar from the server CDN catalogue.
 * Re-renders when the avatar pool or local selection changes.
 */
export function useSkyxPlayerAvatarUrl(
  playerId: string | undefined,
  preferredUrl?: string | null
): string {
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    void ensureServerAvatarPool();
    return GlobalBus.on(SKYX_NEW_PLAYER_AVATAR_CHANGED, () => {
      setRevision(value => value + 1);
    });
  }, []);

  const localPlayerId = AuthService.getInstance().getPlayerId();
  const localNickname = useAuth(s => s.user?.nickname?.trim() || '');

  return useMemo(
    () =>
      resolvePlayerAvatarUrl(
        playerId ?? '',
        localPlayerId,
        preferredUrl,
        localNickname
      ),
    [localPlayerId, localNickname, playerId, preferredUrl, revision]
  );
}
